module.exports = __webpack_public_path__ + "static/img/image_solutions_ic_02.415dff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_ic_02.png
// module id = 10wu
// module chunks = 10